export const MILLISECONDS_IN_SEC = 1000;
export const SECONDS_IN_MIN = 60;
export const MINUTES_IN_HOUR = 60;
